import { createRoot } from "react-dom/client";
import App from "./App";
import { AppContextProvider } from "./contexts/AppContext";
import { ChatAtendenteContextProvider } from "./contexts/ChatAtendenteContext";
import { PusherContext, PusherContextProvider } from "./contexts/PusherContext";
const wrapper =
    document.getElementById("dommus-central-ajuda-shadow")?.shadowRoot ||
    document;
const container = wrapper.getElementById("dommus-central-ajuda");
const root = createRoot(container);
// const authTokenString = container.getAttribute("data-auth-token");
// const usuarioId = container.getAttribute("data-usuario-id");
const usuarioId = 1;
const authTokenString =
    "0mRxRTJToRTY5W87AhMfEEeNarQprnoKt91WuHSh7WUmsMJoMlLChlHj6vx3";

root.render(
    <PusherContextProvider>
        <AppContextProvider>
            <ChatAtendenteContextProvider>
                <App authTokenString={authTokenString} usuarioId={usuarioId} />
            </ChatAtendenteContextProvider>
        </AppContextProvider>
    </PusherContextProvider>
);
